import {get, has} from 'lodash';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {useQuery} from 'react-apollo';
import 'react-placeholder/lib/reactPlaceholder.css';
import {ORDER_DIRECTION} from '../../constants';
import DatatableCore from '../Datatable/DatatableCore';

const Table = ({columns, keyResult, query, defaultSort, customQuery, fetchPolicy}) => {
  const [order, setOrder] = useState(null);
  const setOrderField = (field, sortKey) => {
    let direction = !order || (order && (order.direction === ORDER_DIRECTION.DESC || (![field, sortKey].includes(order.field))))
      ? ORDER_DIRECTION.ASC
      : ORDER_DIRECTION.DESC;

    setOrder({field: sortKey || field, direction});
  };
  const orders = order ? [order] : [];
  if (defaultSort) {
    orders.push(defaultSort);
  }

  let variables = {
    criteria: {
      orders,
    },
  };

  if (customQuery) {
    variables = {
      customQuery,
      ...variables,
    };
  }

  const {loading, error, data} = useQuery(query, {variables, fetchPolicy});
  const result = has(data, keyResult) ? get(data, keyResult) : {};

  return (
    <DatatableCore
      columns={columns}
      onClickSortable={setOrderField}
      loading={loading}
      error={error}
      result={result}
    />
  );
};

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  keyResult: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  customQuery: PropTypes.string,
  defaultSort: PropTypes.shape({
    field: PropTypes.string.isRequired,
    direction: PropTypes.oneOf(Object.values(ORDER_DIRECTION)),
  }),
  fetchPolicy: PropTypes.string,
};

Table.defaultProps = {
  fetchPolicy: 'cache-first',
};

export default Table;
